
// import * as React from 'react'
import { useState, useEffect } from 'react';
import { ChakraProvider, Grid, GridItem, Box} from '@chakra-ui/react'
import  gruntTheme  from "./themes/gruntTheme";
import Header from './components/Header';
//import SideNav from './components/SideNav';
import SideNav2 from './components/SideNav2';

import Knjige from './components/main/Knjige2';
import Operateri from './components/main/Operateri';

import Dashboard from './components/Dashboard/Dashboard';
import Postavke from './components/main/Postavke';
import Osobe from './components/osoba/Osobe2'
import Klaonice from './components/klaonica/Klaonice';
import Pasmine from './components/pasmina/Pasmine';
import Drzave from './components/drzava/Drzave';
import Lokacije from './components/lokacija/Lokacije2';
import Dolasci from './components/dolazak/Dolasci';
import Odlasci from './components/odlazak/Odlasci';
import Izlucenja from './components/izlucenje/Izlucenja';
import GruntComponents  from './components/components';
import LogIn from './components/main/LogIn';
import Registar from './components/registar/Registar';

import {loggedOper as lp} from './util/grunt'
import GovScanContainer from './components/govscan/GovScanContainer';
// import '@fontsource/roboto/400.css'
// import '@fontsource/roboto/700.css'
// import '@fontsource/raleway/400.css'
// import '@fontsource/raleway/700.css'

import './css/rgg.css';
import PopisiGoveda from './components/popisgoveda/PopisiGoveda';
import Specifikacije from './components/specifikacija/Specifikacije';
//import { SideNavSections } from './components/components2';


function App() {
  const [component, setComponent] = useState(GruntComponents.DashBoard.code);
  const [isAuthenticated, setIsAuthenticated]=useState(false);
  //const [iterator,setIterator]=useState(0);
  
/*useEffect(() => {
  setIsAuthenticated(lp.logged);
  
},[iterator]);*/
useEffect(() => {
  setIsAuthenticated(lp.logged);
  
},[]);
  const activeComponent=()=>{
    
    let _component=<Dashboard/>
    if (isAuthenticated) {
      if (component===GruntComponents.Operateri.code) {
        _component=<Operateri onClosePress={closeComponent}/>
      } else 
      if (component===GruntComponents.Knjige.code) {
        _component=<Knjige  onClosePress={closeComponent}/>
        
      } 
      if (component===GruntComponents.Postavke.code) {
        _component=<Postavke onClosePress={closeComponent}/>
      }  
      if (component===GruntComponents.Osobe.code) {
        _component=<Osobe onClosePress={closeComponent}/>
      }
      if (component===GruntComponents.Klaonice.code) {
        _component=<Klaonice onClosePress={closeComponent}/>
      }
      if (component===GruntComponents.Drzave.code) {
        _component=<Drzave onClosePress={closeComponent}/>
      }
      if (component===GruntComponents.Lokacije.code) {
        _component=<Lokacije onClosePress={closeComponent}/>
      }
      if (component===GruntComponents.Pasmine.code) {
        _component=<Pasmine onClosePress={closeComponent}/>
      }
      if (component===GruntComponents.Dolasci.code) {
        _component=<Dolasci onClosePress={closeComponent}/>
      }
      if (component===GruntComponents.Odlasci.code) {
        _component=<Odlasci onClosePress={closeComponent}/>
      }
      if (component===GruntComponents.Izlucenja.code) {
        _component=<Izlucenja onClosePress={closeComponent}/>
      }
      if (component===GruntComponents.Registar.code) {
        _component=<Registar onClosePress={closeComponent}/>
      }
      if (component===GruntComponents.SkeniranjePutnihListova.code) {
        _component=<GovScanContainer onClosePress={closeComponent}/>
      }
      if (component===GruntComponents.PopisGoveda.code) {
        _component=<PopisiGoveda onClosePress={closeComponent}/>
      }
      if (component===GruntComponents.Specifikacije.code) {
        _component=<Specifikacije onClosePress={closeComponent}/>
      }
    } 
    
    return _component;
  }
  const closeComponent=()=>{
    setComponent(GruntComponents.DashBoard);
  }
  const onComponentSelect=(component)=>{
    
    setComponent(component.code);
  }

const selectedMenuItem=(_code)=>{
  setComponent(_code);
}

  const AuthSuccess=()=>{
    setIsAuthenticated(true);
    //setIterator(iterator+1);
    
  }

  const LogOut=()=>{
    //setIterator(iterator+1);
    setComponent(GruntComponents.DashBoard.code);
    setIsAuthenticated(false);
  }

  const LoginControl=()=>{
    if (isAuthenticated) {
      return(<></>)
    } else {
      return(<LogIn shouldOpen={true} onAuthSuccess={AuthSuccess}/>)
    }
  }

  const mainPart=()=>{
    if (isAuthenticated) {
      return (
        // <Grid key="app_grid" templateAreas={`"nav header" "nav main"`}  p='2px'  bg='white'
        // templateRows={'4vh 94vh'} templateColumns={'1fr 9fr'}>
        //   <GridItem key="header_grid_item" area={'header'}>
        //     <Header operater={lp.operater} componentSelectHandler={onComponentSelect} onLogOut={()=>{LogOut()}}/>
        //   </GridItem>
        //   <GridItem key="side_grid_item" area={'nav'}>
        //     {/* <SideNav componentSelectHandler={onComponentSelect}/> */}
        //     <SideNav2 selectedMenu={selectedMenuItem}/>
        //   </GridItem>
        //   <GridItem  key="main_grid_item" area={'main'} overflow={'auto'} >
            
        //       {activeComponent()}
            
        //   </GridItem>
          
        // </Grid>

        <Grid
          key="app_grid"
          templateAreas={`"nav header" "nav main"`}
          p="2px"
          bg="white"
          h="100vh"
          templateRows="auto 1fr"
          templateColumns="auto 1fr"   // ⬅️ promjena: 'auto 1fr' umjesto '1fr 9fr'
          boxSizing='border-box'
        >
          <GridItem key="header_grid_item" area="header">
              <Header operater={lp.operater} componentSelectHandler={onComponentSelect} onLogOut={() => { LogOut() }} />
              
          </GridItem>
          <GridItem key="side_grid_item" area="nav">
            {/* <SideNav componentSelectHandler={onComponentSelect}/> */}
              <SideNav2 selectedMenu={selectedMenuItem} />
          </GridItem>
          <GridItem key="main_grid_item" area="main" overflow="hidden" minH={0} display={'flex'} flexDir={'column'}>
              {activeComponent()}
          </GridItem>
      </Grid>

      )
    }
  }

  return (
    <ChakraProvider theme={gruntTheme}>
      <Box key="app_box">
        {LoginControl()}
        {mainPart()}
        
        </Box>
    </ChakraProvider>
  );
}

export default App;
